import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "./AuthContext";

/**
 * Auth gate for the regular app:
 *  - No user → /login
 *  - must_change_password → /change-password
 *  - Otherwise → render children
 */
export default function ProtectedRoute({ children, requireRole }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div
        data-testid="auth-checking"
        className="min-h-screen flex items-center justify-center bg-[var(--al-bg)] text-[var(--al-text-muted)]"
      >
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );
  }
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  // Iter48 — force password change on first login from provisional pw.
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  // Iter48 — role-gated routes (used for /master/* sub-tree).
  // Iter95 — `master_demo` (read-only master tier) also passes the gate.
  if (requireRole) {
    const r = user.role;
    if (requireRole === "super_admin" && !(r === "super_admin" || r === "admin" || r === "master" || r === "master_demo")) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}
